import { useCallback, useContext } from 'react';
import { usePageInstanceId } from '../../context/PageInstanceIdProvider';
import { APP_MANAGER_ID, scopeIdOf } from '../../pulse/scopeRegistry';
import type { ScopeId } from '../../pulse/types';
import { GlobalStateStoreManagerContext } from '../../stores/GlobalStateStore/GlobalStateStoreProvider';

// Resolves the pulse scope for the current render tree position. Prefers the page manager; falls
// back to the app manager (APP_MANAGER_ID) so call sites above the page provider (e.g. app-scope
// actions) still attribute to a real scope. The app store is always mounted above every page —
// GlobalStateStoreProvider throws "Missing GlobalAppStateStoreProvider" otherwise — so the app id
// is always a valid fallback and there is no unattributed 'unknown' case to guard against.
export function usePulseScope(): (instanceId?: string) => ScopeId {
  const managerId = useContext(GlobalStateStoreManagerContext)?.managerId ?? APP_MANAGER_ID;
  const pageInstanceId = usePageInstanceId();

  return useCallback(
    (instanceId?: string) => scopeIdOf(managerId, instanceId ?? pageInstanceId ?? null),
    [managerId, pageInstanceId],
  );
}
